import React from "react";
import "./NotMatch.scss";

const NotMatch = () => {
    return (
        <h1>NotMatch</h1>
    )
}

export default NotMatch;
